import { DetailedHTMLProps, FocusEvent, TextareaHTMLAttributes, useState } from 'react';
import { MultiLineStringInputViewModel } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { useFormTheme } from '../../contexts/FormTheme/FormThemeContext';
import { JabraValidation } from '../../enums/jabraValidations';

interface JabraTextareaProps
  extends DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
  jssMetadata: ValueFieldProps<MultiLineStringInputViewModel>;
}

const JabraTextarea: React.FC<JabraTextareaProps> = ({ jssMetadata, ...htmlProps }) => {
  const { field, errors, tracker } = jssMetadata;
  const { maxLength, minLength, validationDataModels } = field.model;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!errors?.length;
  const isStringLengthValidationOn = validationDataModels.some(
    (validation) => validation.itemId === JabraValidation.StringLengthValidator
  );
  const onFocus = (event: FocusEvent<HTMLTextAreaElement>) => {
    tracker.onFocusField(field, event?.target?.value);
    setHasFocus(true);
  };
  const onBlur = (event: FocusEvent<HTMLTextAreaElement>) => {
    tracker.onBlurField(field, event?.target?.value);
    setHasFocus(false);
  };

  const { secondaryTextColor } = useFormTheme();

  return (
    <textarea
      {...htmlProps}
      className={classNames(
        `w-full resize-y rounded-lg border px-4 py-3 text-lg text-black outline-none placeholder:${secondaryTextColor}`,
        {
          'border-gray-100 bg-white': !hasFocus && !hasAnyError,
          'border-yellow bg-white': hasFocus,
          'border-error bg-error/20': hasAnyError,
        },
        htmlProps.className
      )}
      maxLength={isStringLengthValidationOn ? maxLength : undefined}
      minLength={isStringLengthValidationOn ? minLength : undefined}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  );
};
export default JabraTextarea;
